import "./App.css";
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route ,Navigate} from "react-router-dom";
import { AuthProvider } from "./contexts/authcontext";
import Home from "./pages/home";
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import ScrollToTop from "./components/layout/scrollToTop";
import Loader from "./components/layout/loader";
import BottomNav from "./components/layout/bottomNav";
// react-toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FloatingSubAd from "./components/items/FloatingSubAd";
import { useAuth } from "./hooks/useAuth";
import LoginTest from "./pages/loginTest";

const Members = React.lazy(() => import("./pages/members"));
const DefaultMembers= React.lazy(()=> import("./components/section/DeafultMembers"))
const RecommendedMembers= React.lazy(()=> import("./components/section/RecommendedMembers"))
const QuickSearch= React.lazy(()=> import("./components/section/QuickSearch"))
const SearchMembers= React.lazy(()=> import("./components/section/SearchMembers"))
const MemberProfile = React.lazy(() => import("./pages/MemberProfile"));
const LogIn = React.lazy(() => import("./pages/login"));
const PricingPlan = React.lazy(() => import("./pages/pricingplan"));
const FourZero = React.lazy(() => import("./pages/fourzero"));
const Community = React.lazy(() => import("./pages/community"));
const SuccessStory = React.lazy(() => import("./pages/SuccessStory"));
const Blog = React.lazy(() => import("./pages/blog"));
const BlogSingle = React.lazy(() => import("./pages/blogsingle"));
const Contact = React.lazy(() => import("./pages/contact"));
const SignUp = React.lazy(() => import("./pages/signup"));
const MyProfile = React.lazy(() => import("./pages/myProfile"));
const UserChats = React.lazy(() => import("./pages/UserChats"));

const Subscriptions = React.lazy(() => import("./pages/subscriptions"));
const SubscribeToBundle = React.lazy(() => import("./pages/SubscribeToBundle"));
const SubscriptionInfo = React.lazy(() => import("./pages/SubsicriptionInfo"));
const UserSettings = React.lazy(() => import("./pages/UserSettings"));

function App() {
  const {role} = useAuth()
  return (
    <div dir="rtl" className="">
    
        <BrowserRouter basename="/">
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true} // if your app is RTL
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        { role!=="star" && <FloatingSubAd/>}
          <ScrollToTop />
          <Header />
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<Home />} />

              <Route path="/members" element={<Members />}>
               <Route index element={<Navigate to="/members/all" replace />} />
        <Route path="all" element={<DefaultMembers />} />
        <Route path="recommended" element={<RecommendedMembers />} />
        <Route path="search" element={<SearchMembers />} />
        <Route path="quick-search" element={<QuickSearch />} />
      </Route>
              <Route
                path="member-profile/:userId"
                element={<MemberProfile />}
              />
              <Route path="my-profile" element={<MyProfile />} />
              <Route path="my-chats" element={<UserChats />} />
              <Route path="login" element={<LogIn />} />
              <Route path="signup" element={<SignUp />} />
           
              <Route path="pricing" element={<PricingPlan />} />
              <Route path="*" element={<FourZero />} />
              <Route path="community" element={<Community />} />
              <Route path="success-story" element={<SuccessStory />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog-single/:blogId" element={<BlogSingle />} />
              <Route path="contact" element={<Contact />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="subscribe-to-bundle/:bundleId" element={<SubscribeToBundle />} />
              <Route path="subscription-info" element={<SubscriptionInfo />} />
              <Route path="user-settings" element={<UserSettings />} />
              <Route path="login-test" element={<LoginTest />} />
            </Routes>
          </Suspense>

          <Footer />
          <BottomNav />
        </BrowserRouter>
    
    </div>
  );
}

export default App;
